import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from 'react-select';
import Switch from '@material-ui/core/Switch';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import CommentIcon from '@material-ui/icons/Comment';
import { Grid } from '@material-ui/core';
import { FormGroup, Label, Spinner } from 'reactstrap';
import SystemLabel from '../../../../../../../system/SystemLabel/SystemLabel';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import { VisibilityOffOutlined } from '@material-ui/icons';
import JirangoSwitch from '../../../../../../../components/JirangoSwitch/JirangoSwitch';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import SaveIcon from '@material-ui/icons/Save';
import PageviewIcon from '@material-ui/icons/Pageview';
import Popover from '@material-ui/core/Popover';
const useStyles = makeStyles((theme) => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: theme.spacing(2),
        minWidth: 120,
    },
    formControlLabel: {
        marginTop: theme.spacing(1),
    },
}));

const customStyles = {
    control: (provided, state) => ({
        ...provided,

        backgroundColor: "#3d3d3d",
        color: "#eee",
        border: "0px",
        maxWidth: "100%"
    }),
    container: (provided, state) => ({
        ...provided,

        width: '100%'
    }),
    noOptionsMessage: (provided, state) => ({
        ...provided,
        color: "green",
        maxWidth: "100%"
    }),
    input: (provided, state) => ({
        ...provided,
        color: "#eee",
        maxWidth: "100%"
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: "#eee"
    }),
    menu: (provided, state) => ({
        ...provided,
        backgroundColor: "#3d3d3d",
        maxWidth: "100%",
        zIndex: 100
    }),
    separatorIndicator: (provided, state) => ({
        ...provided,
        backgroundColor: "transparent",

    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "#20a8d8" : "#3d3d3d",
        color: "#eee",
        ["&:hover"]: {
            backgroundColor: "#5a5959ba"
        }
    }),
    placeholder: provided => ({
        ...provided,
        color: "#eee"
    })
};
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default class ImportModules extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            modules: [],
            groups: [],
            events: [],
            presets: [],
            selectedEvent: null,
            selectedPreset: null,
            currentPresets: [],
            copyAllFromEvent: false,
            copyModules: [],
            destination: null,
            destinationItem: null,
            saving: false
        }

    }
    componentDidMount() {
        const { hubConnection } = this.props;
        if (hubConnection) {
            const { eventId } = this.props;
            hubConnection.on('onGetAllModulesForEvent', this.getModuleGroups)
            hubConnection.invoke('getAllModulesForEvent', eventId)
        }
    }
    getModuleGroups (res){
        const { groups, currentPresets } = res;
        let events = groups.map(g => {
            return { value: g.eventId, label: `${g.eventId} - ${g.eventName}` }
        });
        let cPresets = currentPresets.map(c => {
            return { value: c.presetId, label: c.presetName }
        })
        cPresets = [{ label: <SystemLabel name="OutsideOfPresets" />, value: this.props.eventId }, ...cPresets]
        this.setState({
            events, groups, currentPresets: cPresets, destination: cPresets.length == 1 ? {
                path: 'EVENT',
                id: this.props.eventId
            } : null
        })


    }
    onEventSelected (value){
        if (!value) return;
        const { currentPresets } = this.state;
        const event = this.state.groups.find(g => g.eventId == value)
        let modules = event.modules || []
        let presets = event.presets.map((p, i) => {
            return { label: p.presetName, value: p.presetId }
        });

        presets = [
            { label: <SystemLabel name="JustLoadedModules" />, value: event.eventId },
            ...presets]
        this.setState({ selectedEvent: { label: event.eventName, value: value }, modules: [], copyModules: [], destination: currentPresets.length == 1 ? this.state.destination : null, selectedPreset: null, presets, copyAllFromEvent: false });
    }
    onPresetSelected (selectedPreset) {
        this.setState({ selectedPreset })
        const { groups, selectedEvent } = this.state;

        var ev = groups.find(g => g.presets.find(p => p.presetId == selectedPreset.value));
        let modules = [];
        if (ev) {

            modules = ev.presets.find(p => p.presetId == selectedPreset.value).modules;

        }
        else {
            if (selectedEvent.value == selectedPreset.value) {
                modules = groups.find(g => g.eventId == selectedPreset.value).modules;
            }
        }
        this.setState({ modules, copyModules: modules })

    }
    onDestinationPresetSelected (destination) {
        let d = {
            path: 'PRESET',
            id: destination.value
        };
        let des = null
        if (destination.value == this.props.eventId) {
            d.path = 'EVENT';
            des = { label: <SystemLabel name="OutsideOfPresets" />, value: this.props.eventId }
        } else {
            let p = this.state.currentPresets.find(c => c.value == destination.value);
            if (p) des = p;
        }
        this.setState({ destination: d, destinationItem: des })

    }
    handleClose () {
        this.props.toggleDialog(false);
    };
    onImportModules() {this.setState({ saving: false })}
    handleSave () {
        const { hubConnection } = this.props;
        if (hubConnection) {
            const { eventId } = this.props;
            let isSaving = false;
            if (this.state.copyAllFromEvent && this.state.selectedEvent) {
                hubConnection.invoke('importModules', eventId, this.state.selectedEvent.value, (this.props.user ? this.props.user.userGuid : null), null, null, null)
                isSaving = true;
            }
            else if (this.state.selectedEvent && this.state.selectedPreset && this.state.destination) {
                hubConnection.invoke('importModules', eventId, this.state.selectedEvent.value, (this.props.user ? this.props.user.userGuid : null), this.state.selectedPreset.value, this.state.destination.id, this.state.copyModules.map(x => { return x.digitalMeetingItemId }))
                isSaving = true;

            }
            this.setState({
                selectedEvent: null,
                selectedPreset: null,
                copyAllFromEvent: false,
                copyModules: [],
                modules: [],
                destination: null,
                destinationItem: null,
                saving: false
            })
        }

    }
    checkModule(module) {
        let m = Array.from(this.state.copyModules);
        const add = !m.find(x => x.digitalMeetingItemId == module.digitalMeetingItemId)
        if (add) m.push(module)
        else {
            m = m.filter(x => x.digitalMeetingItemId != module.digitalMeetingItemId)
        }
        this.setState({ copyModules: m })
    }
    setAllChecked (all) {this.setState({ copyModules: all ? this.state.modules : [] })}
    render() {
        const { hubConnection, toggleDialog, isOpen } = this.props;
        const { currentPresets, selectedEvent, selectedPreset, modules, events, presets } = this.state;
        let isSavavle = false;
        if (this.state.copyAllFromEvent) {
            isSavavle = true;
        }
        else if (this.state.copyModules.length > 0 && this.state.destination) {
            isSavavle = true;
        }
        return (
            <React.Fragment>
                <Dialog
                    fullScreen
                    open={isOpen}
                    TransitionComponent={Transition}
                    onClose={this.handleClose}
                >
                    <AppBar >
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <IconButton disabled={!isSavavle} edge="start" color="inherit" onClick={this.handleSave} aria-label="close">
                                <SaveIcon />
                            </IconButton>

                        </Toolbar>
                    </AppBar>

                    <DialogContent className="dark-card" style={{ marginTop: 63, paddingTop: 10, overflowY: 'hidden' }}>
                        <Grid container spacing={3}>
                            <Grid item xs={4} style={{ display: 'flex', width: '100%' }}>
                                <FormGroup style={{ width: '100%' }}>
                                    <Label className="primary-text" >
                                        <SystemLabel name="SelectEvent" />
                                    </Label>
                                    <Select
                                        className="jirango-select"
                                        classNamePrefix="jirango-select"
                                        styles={customStyles}
                                        options={events}
                                        styles={customStyles}
                                        value={selectedEvent}
                                        onChange={selectedOption =>
                                            this.onEventSelected(selectedOption.value)
                                        }
                                    />
                                </FormGroup>
                                {selectedEvent && presets.length > 0 ? <div className="next-arrow">
                                    <ArrowForwardIcon />
                                </div> : null}
                            </Grid>

                            <Grid item xs={4} style={{ display: 'flex', width: '100%' }}>
                                <div style={{ width: '100%' }} >
                                    {selectedEvent && presets.length > 0 ? <FormGroup style={{ width: '100%' }}>
                                        <Label className="primary-text" ><SystemLabel name="CopyFrom" /></Label>
                                        <Select className="jirango-select"
                                            classNamePrefix="jirango-select"
                                            styles={customStyles}
                                            options={presets}
                                            isDisabled={this.state.copyAllFromEvent}
                                            value={selectedPreset}
                                            onChange={selectedOption =>
                                                this.onPresetSelected(selectedOption)
                                            }
                                        />
                                    </FormGroup> : null}
                                    {selectedEvent && presets.length > 1 ? <FormGroup style={{ width: '100%' }}>
                                        <Label className="primary-text" ><SystemLabel name="CopyAllFromEvent" /></Label>
                                        <JirangoSwitch onChange={() => this.setState({
                                            copyAllFromEvent: !this.state.copyAllFromEvent,
                                            modules: [],
                                            selectedPreset: null,
                                            copyModules: [],
                                        })} isChecked={this.state.copyAllFromEvent} />
                                    </FormGroup> : null}
                                </div>
                                {selectedEvent && modules.length > 0 && currentPresets.length > 1 && !this.state.copyAllFromEvent ? <div className="next-arrow">
                                    <ArrowForwardIcon />
                                </div> : null}

                            </Grid>

                            <Grid item xs={4}>
                                {selectedEvent && modules.length > 0 && currentPresets.length > 1 && !this.state.copyAllFromEvent ? <FormGroup>
                                    <Label className="primary-text" ><SystemLabel name="CopyTo" /></Label>
                                    <Select className="jirango-select"
                                        classNamePrefix="jirango-select"
                                        styles={customStyles}
                                        options={currentPresets}
                                        value={this.state.destinationItem}
                                        onChange={selectedOption =>
                                            this.onDestinationPresetSelected(selectedOption)
                                        }
                                    />
                                </FormGroup> : null}
                            </Grid>

                        </Grid>
                      
                        {modules.length > 0 ? <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <FormGroup>
                                    <Label className="primary-text"  ><SystemLabel name="SelectedModules" /></Label>
                                    <p className="secondary-text" >  <SystemLabel name="SelectModulesYouWannaCopy" /></p>
                                    {modules.length > 0 ? <CheckboxList
                                        copyAll={this.state.copyAllFromEvent}
                                        copyModules={this.state.copyModules}
                                        checkModule={this.checkModule}
                                        setAllChecked={this.setAllChecked}
                                        modules={this.state.modules} /> : <SystemLabel name="NoModulesFound" />
                                    }

                                </FormGroup>
                            </Grid>
                        </Grid> : null}
                    </DialogContent>
                </Dialog>
            </React.Fragment >
        );
    }

}

function CheckboxList({ modules = [], copyAll = false, copyModules = [], setAllChecked = () => null, checkModule = () => null }) {
    return (
        <div>
            <ListItem dense button onClick={() => setAllChecked((modules.length != copyModules.length))}>
                <ListItemIcon>
                    <Checkbox
                        edge="start"
                        icon={<CheckBoxOutlineBlankIcon className="secondary-text" />}
                        checkedIcon={<CheckBoxOutlinedIcon className="primary-text" />}
                        checked={(modules.length == copyModules.length)}
                        tabIndex={-1}
                        disableRipple

                    />
                </ListItemIcon>
                <ListItemText className="primary-text" primary={<SystemLabel name="SelectAll" />} />
            </ListItem>
            <hr style={{ margin: 0, border: '1px solid #545454' }} />
            <List className="dark-list" style={{
                maxHeight: 'calc(100vh - 342px)',
                overflowY: 'auto'
            }}>
                {modules.map((m, i) => {
                    const labelId = `checkbox-list-label-${i}`;

                    return (
                        <ListItem key={i} role={undefined} dense button onClick={() => checkModule(m)}>
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    icon={<CheckBoxOutlineBlankIcon className="secondary-text" />}
                                    checkedIcon={<CheckBoxOutlinedIcon className="primary-text" />}
                                    checked={copyModules.find(d => d.digitalMeetingItemId == m.digitalMeetingItemId)}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': i }}
                                />
                            </ListItemIcon>
                            <ListItemText className="primary-text" id={labelId} primary={
                                <React.Fragment>
                                    {m.displayName || ''}{"  ("}<SystemLabel name={m.name} />{")"}
                                </React.Fragment>
                            } />
                        </ListItem>
                    );
                })}
            </List>
        </div>

    );
}


/* import { makeStyles } from '@material-ui/core/styles'; */

/* const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
    },
})); */

function PreviewPop(props) {
    /*     const classes = useStyles(); */
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <div>
            <PageviewIcon
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            />
            <Popover
                id="mouse-over-popover"
                /*   className={classes.popover}
                  classes={{
                      paper: classes.paper,
                  }} */
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                {props.children}
            </Popover>
        </div>
    );
}

